import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaTimelineItem from './VaTimelineItem.vue'

export default withConfigTransport(VaTimelineItem as any)
